<div
  class="pastille {{ color }}"
  [class.cursor-help]="tooltip"
  [matTooltip]="tooltip ?? ''"
>
  <span class="bulle"></span>
</div>
